"use strict";

var moduleName = "scroll-to-anchor";

module.exports = function () {
	$("body").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Плавный скролл к якорю
		//

		$(document).ready(function() {

			$("a[href^=\"#anchor-\"]").on("click", function (e) {
				e.preventDefault();

				var id  = $(this).attr("href"),
					top = $(id).offset().top;

				$("body,html").animate({scrollTop: top}, 800);
			});
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/scrollingToAnchorInit.js
 **/